
import { useState } from 'react';

export const useFormReset = () => {
  const [showThankYou, setShowThankYou] = useState(false);
  const [formKey, setFormKey] = useState(0);

  const resetForm = () => {
    // Clear localStorage items
    localStorage.removeItem('formData');
    localStorage.removeItem('devices');
    localStorage.removeItem('duration');
    localStorage.removeItem('selectedLocations');
    localStorage.removeItem('creativeUrls');
    localStorage.removeItem('startDate');
    localStorage.removeItem('endDate');
    localStorage.removeItem('locationCreatives');
    localStorage.removeItem('mediaOwnerCreatives');
    localStorage.removeItem('campaignName');
    localStorage.removeItem('useLocationSpecificCreatives');
    localStorage.removeItem('useMediaOwnerSpecificCreatives');
    localStorage.removeItem('creatives');
    
    // Show thank you popup immediately
    setShowThankYou(true);
    
    // Increment form key to force re-render
    setFormKey(prev => prev + 1);
  };

  return {
    showThankYou,
    setShowThankYou,
    formKey,
    resetForm
  };
};
